import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { constants } from 'crypto';

@Injectable({
  providedIn: 'root'
})
export class DoRuleService {

  constructor(
    private http: HttpClient
  ) {

  }

  getDoRule(ruleName: string, facility: String, carCategory: string): Observable<any>{
    var url = `${environment.logisticsApiUrl}/bookingDoRule/temp/${ruleName}`;
    if(!isNullOrEmpty(facility) || !isNullOrEmpty(carCategory)){
      url = `${url}?facility=${facility}&carCategory=${carCategory}`;
    }
    return this.http.get(url);
  }

  deleteDoRule(seqNo: Number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp/${seqNo}`;
    return this.http.delete(url);
  }

  getDoColumns(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/doColumn`;
    return this.http.get(url);
  }

  addRule(insertObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp`;
    return this.http.post(url, insertObj);
  }

  updateRule(updateObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp`;
    return this.http.put(url, updateObj);
  }

  saveSimulate(insertObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp/condition`;
    return this.http.post(url, insertObj);
  }

  getSimulateResult(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp/condition`;
    return this.http.get(url);
  }

  /**
   * Get Tenant Options for DropDown
   */
   getTenantOptions(): Observable<any> {
    const url = `${environment.authUrl}/tenant`;
    return this.http.get(url);
  }

  getDashBoardUrl(): string {
    return `${environment.dashboardUrl}`;
  }

  importIntoTemp(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp/import`;
    return this.http.get(url);
  }

  exportToReal(conditionSeqNo: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/bookingDoRule/temp/export/${conditionSeqNo}`;
    return this.http.get(url);
  }
}
